import React, { useEffect } from 'react';
import { CheckCircledIcon, Cross2Icon } from '@radix-ui/react-icons';

interface SubscriptionToastProps {
  title: string;
  message: string;
  onClose: () => void;
  duration?: number;
}

export const SubscriptionToast: React.FC<SubscriptionToastProps> = ({
  title,
  message,
  onClose,
  duration = 5000,
}) => {
  useEffect(() => {
    const timer = window.setTimeout(onClose, duration);
    return () => window.clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <div className="subscription-toast" role="status" aria-live="polite">
      <CheckCircledIcon className="subscription-toast__icon" aria-hidden="true" />
      <div className="subscription-toast__copy">
        <strong>{title}</strong>
        <p>{message}</p>
      </div>
      <button
        type="button"
        className="subscription-toast__close"
        onClick={onClose}
        aria-label="Dismiss notification"
      >
        <Cross2Icon />
      </button>
    </div>
  );
};
